import { HexaDirection } from './HexaDirection';
import { TableUtils } from './TableUtils';
export class HexagonalUtils {
    static getNeighbors(coord, distance = 1) {
        const result = [];
        for (const direction of HexaDirection.factory.all) {
            result.push(coord.getNext(direction, distance));
        }
        return result;
    }
    static areNeighbors(first, second) {
        for (const direction of HexaDirection.factory.all) {
            if (first.getNext(direction).equals(second)) {
                return true;
            }
        }
        return false;
    }
    static createBoard(size, empty, full) {
        const height = 2 * size;
        const width = 2 * height;
        const board = TableUtils.create(width, height, empty);
        // ADI: ascending diagonal index
        // DDI: descending diagonal index
        const minimalAdi = size - (size % 2);
        const maximalAdi = minimalAdi + width - 1;
        const minimalDdi = size - height + ((size + 1) % 2);
        const maximalDdi = width - size - (size % 2);
        for (let x = 0; x < width; x++) {
            for (let y = 0; y < height; y++) {
                const adi = x + y;
                const ddi = x - y;
                if (minimalAdi <= adi && adi <= maximalAdi &&
                    minimalDdi <= ddi && ddi <= maximalDdi) {
                    board[y][x] = full;
                }
            }
        }
        return board;
    }
}
